export const CONFIG_NAMESPACE         = 'vocento.config.adbd';

export const COOKIE_NAME              = '__adbd__';
export const COOKIE_DOMAIN            = `.${window.vocento.site.tlddomain}`; // NOTE: tldDomain to set as PATH parameter when save the cookie

export const EMBED_LAYER_PARAM        = 'layer.html'; // NOTE: Final of the URL to get LAYER content
export const EMBED_MODAL_PARAM        = 'modal.html'; // NOTE: Final of the URL to get MODAL content

export const EMBED_CONTAINER_SELECTOR = '[data-voc-adbd-layer]'; // NOTE: Selector to find the container where embed content
export const ADBLOCK_READY_NS         = 'adbd:ready';

export const DetectorType = Object.freeze({
  FILE: 'file'
});

export const BehaviorTypes = Object.freeze({
  REDIRECT: 'redirect',
  EMBED:    'embed'
});

export const DEFAULTS = {
  disabledUserTypes: ['trial', 'suscriptor'],
  disabledCountries: ['ALL', '!ES'], // NOTE: all but Spain
  disabledDevices: [],
  strategies: [
    {
      type: 'file',
      config: {
        traps: []
      }
    }
  ],
  behavior: {
    type: 'embed',
    url: '/',        // NOTE: url used to redirect or get the alert content
    queryString: '', // NOTE: querystring to append the url
    delay: 5,        // NOTE: delay in seconds
  }
};



// WEBPACK FOOTER //
// ./src/constants.js